import * as yup from 'yup';
import Endpoints from '@internal/common';

export interface FormData {
  name: string;
  phoneNumber: string;
}

yup.setLocale({
  mixed: {
    required: 'Dette felt er obligatorisk'
  }
});

export const validationSchema = () => {
  return yup.object().shape({
    name: yup.string(),
    phoneNumber: yup.string().required()
  });
};

export const to = (_body: any) => {
  return 'thomas.lovstrom@gjensidige.dk,peter-ploug.rasmussen@gjensidige.dk,Nicki.Ipsen@gjensidige.dk';
};

export const getPartnerUrl = () => {
  const path: string = window.location.pathname;
  const lastSegment: string = path.substring(path.lastIndexOf('/') + 1).replace(/[^A-Za-z0-9]/g,'');
  const partner = Partners[lastSegment?.toLowerCase()] || Partners.hyundai;
  return `${Endpoints.PartnerLeads}${partner ? `?partner=${partner}` : ''}`;
};

const Partners: {[name: string]: string} = {
  hyundai: 'Hyundai',
  mg: 'MG',
  skoda: 'Skoda',
  lexus: 'Lexus',
  kia: 'Kia',
  toyota: 'Toyota'
};

export default validationSchema;
